import React from "react";
import { Redirect } from "react-router-dom";
import { SUPERUSER_LOCATION_ACCOUNT_KEY } from "actions/super_user";
import { Error } from "components/chrome/main_view/info_messages";
import Loader from "components/shared/loader";
import { useBrandGroups } from "entities/hooks/useBrandGroups";
import { getRedirect } from "helpers/routes";
import { isSuperUser } from "helpers/user";
import { useUser } from "users/hooks/useUser";

export const BaseRouteRedirect = () => {
  const { data: brandGroups, error } = useBrandGroups();
  const { data: user } = useUser();

  if (error) {
    return (
      <Error title="Please Try Again">
        There was an error processing your request. Please reload the page and
        try again.
      </Error>
    );
  }

  if (!brandGroups || !user?.email) {
    return <Loader />;
  }

  if (!brandGroups.length) {
    // Super users do not have a fixed list of stores so if a cookie has not yet been set
    // the entities list will be empty and we push them to select one
    if (isSuperUser(user.email)) {
      return <Redirect to="/superuser/search" />;
    }

    return (
      <Error title="Please Try Again">
        There was an error processing your request. Please reload the page and
        try again.
      </Error>
    );
  }

  const locationNameTarget =
    localStorage.getItem(SUPERUSER_LOCATION_ACCOUNT_KEY) || "";
  localStorage.setItem(SUPERUSER_LOCATION_ACCOUNT_KEY, "");
  const redirectPathname = getRedirect(
    brandGroups,
    undefined,
    undefined,
    locationNameTarget
  );
  return (
    <Redirect to={{ pathname: redirectPathname, state: { firstLoad: true } }} />
  );
};
